import Hyphenate from 'components/hyphenate/Hyphenate';

export function split(str: string): JSX.Element {
  if (str.includes('///')) {
    return (
      <span>
        {str.split('///').map(line => (
          <span className="link-line" key={line}>
            {line}
          </span>
        ))}
      </span>
    );
  }
  return <Hyphenate text={str} />;
}
